@if (isV2 && currentDeviceView === WidgetDeviceViews.Mobile) {
  <button
    type="button"
    class="device-select-btn"
    [class.mobile-only]="currentDevice === EditingDevices.Mobile"
    [matMenuTriggerFor]="deviceMenu"
    [matTooltip]="
      currentDevice === EditingDevices.Any ? ('campaign.widget.device-setting-any' | translate) : ('campaign.widget.device-setting-mobile' | translate)
    ">
    <mat-icon>{{ currentDevice === EditingDevices.Any ? "devices" : "smartphone" }}</mat-icon>
  </button>
  <mat-menu #deviceMenu="matMenu">
    <button mat-menu-item (click)="selectDevice(EditingDevices.Any)">
      <mat-icon>devices</mat-icon>
      <span>{{ "campaign.widget.device-setting-any" | translate }}</span>
    </button>
    <button
      mat-menu-item
      [disabled]="disableMobileEditingDevice"
      [matTooltip]="disableMobileEditingDevice ? ('campaign.widget.device-setting-mobile-disabled-full-width' | translate) : null"
      (click)="selectDevice(EditingDevices.Mobile)">
      <mat-icon>smartphone</mat-icon>
      <span>{{ "campaign.widget.device-setting-mobile" | translate }}</span>
    </button>
  </mat-menu>
} @else {
  @if (currentDeviceView === WidgetDeviceViews.Mobile) {
    <mat-button-toggle-group
      hideSingleSelectionIndicator="true"
      [(ngModel)]="currentDevice"
      (change)="updateEditingDevice.emit({ currentDevice })"
      class="device-toggle-buttons">
      <mat-button-toggle value="{{ EditingDevices.Any }}" matTooltip="{{ 'campaign.widget.device-setting-any' | translate }}">
        <mat-icon>devices</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle
        value="{{ EditingDevices.Mobile }}"
        [disabled]="disableMobileEditingDevice"
        matTooltip="{{
          (disableMobileEditingDevice ? 'campaign.widget.device-setting-mobile-disabled-full-width' : 'campaign.widget.device-setting-mobile') | translate
        }}">
        <mat-icon>phone_iphone</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  }
}
